<div class="row">
    <app-toast [toastModel]="toastModel" *ngIf="isToastShow"></app-toast>
    <div class="col-md-3">
        <!-- <div class="text-blue mt-2" *ngIf="(ruleBooks.data && (ruleBooks.data.length>0))">
            {{this.firstRow}} out of {{ruleBooks.totalCount}}
        </div> -->
    </div>
    <div class="col-md-9">
        <div class="pull-right" style="right: 20px;">
            <span class="cursor-pointer font-color" *ngIf="commonService.checkPlanTypeAction('LRANL')"
                (click)="bulkRuleAnalytics()">Rule Analytics</span>
            <span class="cursor-pointer font-color pl-3" *ngIf="commonService.checkPlanTypeAction('LINR')"
                (click)="insertNewRule()">Insert New Rule</span>
            <span class="cursor-pointer font-color pl-3" *ngIf="commonService.checkPlanTypeAction('LMASSA')"
                (click)="mergeAndStartSelfAssessmentRules()">Merge & Start
                Self-Assessment</span>
            <span class="cursor-pointer font-color pl-3" *ngIf="commonService.checkPlanTypeAction('LSSA')"
                (click)="startSelfAssessmentRules()">Start Self-Assessment</span>
            <span class="text-capitalize pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true"
                [autoClose]="false">
                <span dropdownToggle class="dropdown-toggle cursor-pointer text-blue">
                    Filters <span class="caret" #dropInput></span>
                </span>
                <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu p-3" role="menu"
                    aria-labelledby="button-triggers-manual">
                    <div class="dropdown-filter-part">
                        <app-rulebook-filters (OnFilter)="OnFilter($event)"></app-rulebook-filters>
                        <button class="fa fa-times cross-button filter-close-button"
                            (click)="dropInput.click()"></button>
                    </div>
                </div>
            </span>
            <span class="pl-3" dropdown #dropdown="bs-dropdown" [insideClick]="true" [autoClose]="false">
                <span dropdownToggle class="cursor-pointer text-blue">
                    <span class="fa fa-cog setting-icon" #dropInputsettings></span>
                </span>
                <div class="row">
                    <div class="col-lg-9"></div>
                    <div class="col-lg-3">
                        <div id="dropdown-triggers-manual" *dropdownMenu class="dropdown-menu p-3" role="menu"
                            aria-labelledby="button-triggers-manual">
                            <div class="dropdown-filter-part pt-2">
                                <div class="item-active" *ngFor="let item of itemActiveModel">
                                    <input type="checkbox"
                                        (change)="showHideColumn(item.itemTitle, item.itemWidth, item.isActive, 'Change')"
                                        [(ngModel)]="item.isActive" [attr.checked]="item.isActive ? 'checked' : null" />
                                    <span class="ml-2">{{ item.itemTitle }}</span>
                                </div>
                                <!-- <button class="btn btn-sm float-right mt-2 w-100 btn-blue text-white">Done</button> -->
                                <!-- <button class="fa fa-times cross-button filter-close-button" type="button"
                                    (click)="dropInputsettings.click()"></button> -->
                            </div>
                        </div>
                    </div>
                </div>
            </span>
        </div>
    </div>
</div>
<p-table  [value]="ruleBooks.data" [scrollable]="true" scrollHeight="550px" [virtualScroll]="true"
  [virtualScrollItemSize]="46" [lazy]="true"
  (onLazyLoad)="loadData($event)">
  <ng-template pTemplate="header" let-columns>
    <tr>
        <th>Code</th>
        <th>Name</th>
        <th>Category</th>
        <th>Quantity</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex" >
    <tr>
        <td>{{ product.id }}</td>
        <td>{{ product.regulator }}</td>
        <td>{{ product.title }}</td>
        <td>{{ product.part }}</td>
    </tr>
  </ng-template>
</p-table>
<div class="card">
        <!-- <p-table  #myTable [value]="ruleBooks.data" dataKey="id" class="rulebook_table " [expandedRowKeys]="expandedRows"
        [scrollable]="true" [rows]="20" 
        scrollHeight="350px"
        virtualScroll="true"
        [lazy]="true" (onLazyLoad)="loadData($event)"
        [ngClass]="totalActiveColumn >9 ? 'rulebook_table_horizontal_scroll' : ''" scrollDirection="horizontal"
        styleClass="scrollable-table" (scroll)="onScroll($event)"> -->
        <p-table  #myTable 
        [value]="ruleBooks.data" dataKey="id"
        [expandedRowKeys]="expandedRows"
        [scrollable]="true"
        scrollHeight="650px"
        [rows]="10"
        [virtualScroll]="true"
        [virtualScrollItemSize]="46"
        [lazy]="true"
        (onLazyLoad)="loadData($event)"
      >
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 50px;">
                    <i class="fa fa-check-square icon-font" (click)="removeSelectedItems()"
                        *ngIf="selectedRulebookIds.length > 0" aria-hidden="true"></i>
                </th>
                <th (click)="sortRulebooks('id')" style="width: 100px;">
                    Id
                </th>
                <th *ngIf="rulebookColumns.regulator" (click)="sortRulebooks('regulator')" style="width: 146px;">
                    Regulator
                    <i class="fa" [ngClass]="{'fa-sort-amount-asc': (rulebookFilter.SortKey === 'regulator' && !rulebookFilter.IsDesc),
              'fa-sort-amount-desc': (rulebookFilter.SortKey === 'regulator' && rulebookFilter.IsDesc) }"
                        aria-hidden="true">
                    </i>
                </th>
                <th *ngIf="rulebookColumns.title" (click)="sortRulebooks('title')" style="width: 146px;">
                    Title
                    <i class="fa" [ngClass]="{'fa-sort-amount-asc': (rulebookFilter.SortKey === 'title' && !rulebookFilter.IsDesc),
              'fa-sort-amount-desc': (rulebookFilter.SortKey === 'title' && rulebookFilter.IsDesc) }"
                        aria-hidden="true">
                    </i>
                </th>
                <th *ngIf="rulebookColumns.part" style="width: 400px;">
                    Part
                </th>
                <th *ngIf="rulebookColumns.effectiveDate" (click)="sortRulebooks('effectiveDate')"
                    style="width: 130px;">
                    Effective Date
                    <i class="fa" [ngClass]="{'fa-sort-amount-asc': (rulebookFilter.SortKey === 'effectiveDate' && !rulebookFilter.IsDesc),
              'fa-sort-amount-desc': (rulebookFilter.SortKey === 'effectiveDate' && rulebookFilter.IsDesc) }"
                        aria-hidden="true">
                    </i>
                </th>
                <th *ngIf="rulebookColumns.version" (click)="sortRulebooks('version')" class="text-center"
                    style="width: 130px;">
                    Version
                    <i class="fa" [ngClass]="{'fa-sort-amount-asc': (rulebookFilter.SortKey === 'version' && !rulebookFilter.IsDesc),
              'fa-sort-amount-desc': (rulebookFilter.SortKey === 'version' && rulebookFilter.IsDesc) }"
                        aria-hidden="true">
                    </i>
                </th>
                <th *ngIf="rulebookColumns.isApplicable" (click)="sortRulebooks('applicable')" class="text-center"
                    style="width: 130px;">
                    Applicable
                    <i class="fa" [ngClass]="{'fa-sort-amount-asc': (rulebookFilter.SortKey === 'applicable' && !rulebookFilter.IsDesc),
              'fa-sort-amount-desc': (rulebookFilter.SortKey === 'applicable' && rulebookFilter.IsDesc) }"
                        aria-hidden="true">
                    </i>
                </th>
                <th *ngIf="rulebookColumns.isRead" class="text-center" style="width: 130px;">
                    <span>Read</span>
                    <span dropdown [insideClick]="true" [autoClose]="true">
                        <span class="fa fa-filter p-1 ml-2 border" id="button-basic" dropdownToggle
                            aria-controls="dropdown-basic">
                        </span>
                        <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                            aria-labelledby="button-basic"
                            style="max-height: 150px; overflow-y: auto; max-width: 225px;">
                            <div class="form-group p-2 mb-0">
                                <select class="form-control form-control-sm" (change)="getFilteredRulebooks()"
                                    [(ngModel)]="isRulebookRead">
                                    <option value="-1">Select</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                        </div>
                    </span>
                </th>
                <th *ngIf="rulebookColumns.isOperative" class="text-center" style="width: 130px;">
                    <span>Operative</span>
                    <span dropdown [insideClick]="true" [autoClose]="true">
                        <span class="fa fa-filter p-1 ml-2 border" id="button-basic" dropdownToggle
                            aria-controls="dropdown-basic">
                        </span>
                        <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                            aria-labelledby="button-basic"
                            style="max-height: 150px; overflow-y: auto; max-width: 225px;">
                            <div class="form-group p-2 mb-0">
                                <select class="form-control form-control-sm" (change)="getFilteredRulebooks()"
                                    [(ngModel)]="isRulebookOperative">
                                    <option value="-1">Select</option>
                                    <option value="1">Yes</option>
                                    <option value="0">No</option>
                                </select>
                            </div>
                        </div>
                    </span>
                </th>

                <th *ngIf="rulebookColumns.ruleId" style="width: 150px;">
                    <span (click)="sortRulebooks('ruleId')">
                        Rule ID
                        <i class="fa" [ngClass]="{'fa-sort-amount-asc': (rulebookFilter.SortKey === 'ruleId' && !rulebookFilter.IsDesc),
              'fa-sort-amount-desc': (rulebookFilter.SortKey === 'ruleId' && rulebookFilter.IsDesc) }"
                            aria-hidden="true">
                        </i>
                    </span>
                    <span dropdown [insideClick]="true" [autoClose]="true">
                        <span class="fa fa-filter p-1 ml-2 border"
                            [ngClass]="selectedRuleIdFilters.length>0?'text-blue border-primary':''" id="button-basic"
                            dropdownToggle aria-controls="dropdown-basic">
                        </span>
                        <div id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu"
                            aria-labelledby="button-basic"
                            style="max-height: 150px; overflow-y: auto; max-width: 225px;">
                            <div class="form-group p-2 mb-0">
                                <mat-chip-list #ruleIdList>
                                    <ng-container *ngFor="let ruleId of selectedRuleIdFilters">
                                        <mat-chip [selectable]="selectable" [removable]="removable"
                                            (removed)="removeRuleId(ruleId)">
                                            {{ruleId}}
                                            <mat-icon matChipRemove>x</mat-icon>
                                        </mat-chip>
                                    </ng-container>
                                    <input class="form-control form-control-sm mat-autodd-input border-bottom"
                                        #ruleIdInput [formControl]="ruleIdCntrl" [matAutocomplete]="ruleIdAutocomplete"
                                        [matChipInputFor]="ruleIdList"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        [matChipInputAddOnBlur]="addOnBlur" (matChipInputTokenEnd)="addRuleId($event)">
                                </mat-chip-list>
                                <mat-autocomplete #ruleIdAutocomplete="matAutocomplete"
                                    (optionSelected)="selectRuleId($event)">
                                    <mat-option *ngFor="let ruleId of searchedRuleId" [value]="ruleId">
                                        {{ruleId}}
                                    </mat-option>
                                </mat-autocomplete>
                            </div>
                        </div>
                    </span>
                </th>
                <th *ngIf="rulebookColumns.owner" (click)="sortRulebooks('owner')" style="width: 140px;">
                    Owner
                    <i class="fa" [ngClass]="{'fa-sort-amount-asc': (rulebookFilter.SortKey === 'owner' && !rulebookFilter.IsDesc),
              'fa-sort-amount-desc': (rulebookFilter.SortKey === 'owner' && rulebookFilter.IsDesc) }"
                        aria-hidden="true">
                    </i>
                </th>
                <th style="width: 150px;">
                    Actions
                </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-ruleBook let-rowIndex="rowIndex" let-expanded="expanded">
            <tr class="data_td tr-bold" *ngIf="(ruleBooks.data && (ruleBooks.data.length>0))"
                [ngClass]="rowIndex%2==0?'background':'backgroundOdd'" style="height:250px">
                <td style="width: 50px;">
                    <i class="fa fa-square-o icon-font" (click)="selectRulebook('Checked', ruleBook)"
                        *ngIf="!isSelectedItem(ruleBook.id)" aria-hidden="true"></i>
                    <i class="fa fa-check-square icon-font" (click)="selectRulebook('UnChecked', ruleBook)"
                        *ngIf="isSelectedItem(ruleBook.id)" aria-hidden="true"></i>
                </td>
                <td style="width: 100px;">
                    <span><a (click)="openView(ruleBook.id,2)" target="_blank">{{ruleBook.id}}</a></span>
                </td>
                <td *ngIf="rulebookColumns.regulator" style="width: 146px;">
                    {{ruleBook.regulator}}
                </td>
                <td *ngIf="rulebookColumns.title" title="{{ruleBook.regulatorRuleFullRequirement}}"
                    style="width: 146px;">
                    {{ruleBook.title}}
                </td>
                <td *ngIf="rulebookColumns.part" style="width: 400px;">
                    {{ruleBook.part}}
                </td>
                <td *ngIf="rulebookColumns.effectiveDate" style="width: 130px;">
                    {{ruleBook.effectiveDate | date:'dd-MMM-yyyy'}}
                </td>
                <td *ngIf="rulebookColumns.version" class="text-center" style="width: 130px;">
                    {{ruleBook.version}}
                </td>
                <td *ngIf="rulebookColumns.isApplicable" class="text-center" style="width: 130px;">
                    <i class="fa fa-square-o icon-font"
                        *ngIf="!ruleBook.applicable&& currentUserRole !== 'Compliance Enterprise'"
                        aria-hidden="true"></i>
                    <i class="fa fa-square-o icon-font"
                        (click)="enableRule(ruleBook.id, 'Applicable'); ruleBook.applicable = true"
                        *ngIf="!ruleBook.applicable && currentUserRole === 'Compliance Enterprise' && commonService.checkPlanTypeAction('LRA')"
                        aria-hidden="true"></i>
                    <i class="fa fa-check-square icon-font" (click)="openDeleteDialog(ruleBook.id, 'Applicable');"
                        *ngIf="ruleBook.applicable && currentUserRole === 'Compliance Enterprise' && commonService.checkPlanTypeAction('LRA')"
                        aria-hidden="true"></i>
                    <i class="fa fa-check-square icon-font"
                        *ngIf="ruleBook.applicable && currentUserRole !== 'Compliance Enterprise'"
                        aria-hidden="true"></i>
                </td>
                <td *ngIf="rulebookColumns.isRead" class="text-center" style="width: 130px;">
                    <i class="fa fa-square-o icon-font"
                        *ngIf="!ruleBook.isRead&& currentUserRole !== 'Compliance Enterprise'" aria-hidden="true"></i>
                    <i class="fa fa-square-o icon-font"
                        (click)="enableRule(ruleBook.id, 'Read'); ruleBook.isRead = true"
                        *ngIf="!ruleBook.isRead && currentUserRole === 'Compliance Enterprise' && commonService.checkPlanTypeAction('LRR')"
                        aria-hidden="true"></i>
                    <i class="fa fa-check-square icon-font" (click)="openDeleteDialog(ruleBook.id, 'Read');"
                        *ngIf="ruleBook.isRead && currentUserRole === 'Compliance Enterprise' && commonService.checkPlanTypeAction('LRR')"
                        aria-hidden="true"></i>
                    <i class="fa fa-check-square icon-font"
                        *ngIf="ruleBook.isRead && currentUserRole !== 'Compliance Enterprise'" aria-hidden="true"></i>
                </td>
                <td *ngIf="rulebookColumns.isOperative" class="text-center" style="width: 130px;">
                    <i class="fa fa-square-o icon-font"
                        *ngIf="!ruleBook.operative&& currentUserRole !== 'Compliance Enterprise'"
                        aria-hidden="true"></i>
                    <i class="fa fa-square-o icon-font"
                        (click)="enableRule(ruleBook.id, 'Operative'); ruleBook.operative = true"
                        *ngIf="!ruleBook.operative && currentUserRole === 'Compliance Enterprise' && commonService.checkPlanTypeAction('LRO')"
                        aria-hidden="true"></i>
                    <i class="fa fa-check-square icon-font" (click)="openDeleteDialog(ruleBook.id, 'Operative');"
                        *ngIf="ruleBook.operative && currentUserRole === 'Compliance Enterprise' && commonService.checkPlanTypeAction('LRO')"
                        aria-hidden="true"></i>
                    <i class="fa fa-check-square icon-font"
                        *ngIf="ruleBook.operative && currentUserRole !== 'Compliance Enterprise'"
                        aria-hidden="true"></i>
                </td>
                <td *ngIf="rulebookColumns.ruleId" style="width: 150px;">
                    <span>{{ruleBook.ruleId}}</span>
                </td>
                <td *ngIf="rulebookColumns.owner" style="width: 140px;">
                    {{ruleBook.owner}}
                </td>
                <td style="width: 150px;">
                    <a (click)="openView(ruleBook.id,2)" target="_blank"
                        *ngIf="commonService.checkPlanTypeAction('LV')"> View | </a>
                    <a href="{{ruleBook.hyperlink}}" target="_blank"
                        *ngIf="commonService.checkPlanTypeAction('LL')">Link |
                    </a>
                    <span *ngIf="ruleBook.insertedRow == 1">Insert Row | </span>
                    <span class="font-color cursor-pointer"
                        *ngIf="ruleBook.insertedRow == 0 && commonService.checkPlanTypeAction('LIR')"
                        (click)="insertedRow(ruleBook)">Insert Row | </span>
                    <span *ngIf="ruleBook.editableRow == 0">Edit | </span><span class="font-color cursor-pointer"
                        *ngIf="ruleBook.editableRow == 1 && commonService.checkPlanTypeAction('LE')"
                        (click)="editRow(ruleBook)">Edit | </span>
                    <span *ngIf="ruleBook.insertedRow == 0">Delete</span><span class="font-color cursor-pointer"
                        *ngIf="ruleBook.insertedRow == 1 && commonService.checkPlanTypeAction('LD')"
                        (click)="openDeleteModel(ruleBook.id)">Delete</span>
                </td>
            </tr>
            
            <tr *ngIf="(ruleBooks.data.length==0)">
                <td [attr.colspan]="totalActiveColumn">
                    <span>No Data Available</span>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="rowexpansion" let-ruleBook let-rowIndex="rowIndex">
            <tr>
                <td [attr.colspan]="totalActiveColumn" class="desc-body data_td" *ngIf="totalActiveColumn>0">
                    huuu
                </td>
            </tr>
        </ng-template>
       
       
    </p-table>
</div> 